import { Component, OnInit } from '@angular/core';
import { PermissionService } from '../../shared/services/permission.service'
import { MenuConfig } from '../../shared/classes/MenuConfig'
import { Adal4Service } from "adal-angular4";
import { UserService } from '../../shared/services/user.service';
import { AppEnvironmentService } from '../../shared/services/app-environment.service';

@Component({
  selector: 'app-menu',
  templateUrl: './menu.component.html',
  styleUrls: ['./menu.component.css'],
  providers: [UserService, AppEnvironmentService]
})
export class MenuCompoment implements OnInit {

  menuItens: MenuConfig[];
  canLogout: boolean = false;
  user: string;
  ambiente: string = "";
  sessionMinutes: number;
  sessionSeconds: number;
  distance: number = 0;
  logado: boolean;
  alertShowed: boolean = false;
  expiration;
  counter;
  versao = "1.3.1";
  constructor(private adalService: Adal4Service, 
    private permissionService : PermissionService, 
    private userService: UserService,
    private appEnvService: AppEnvironmentService) { }

  ngOnInit() {
    this.adalService.handleWindowCallback();
    this.setAmbiente();
    
    if(this.adalService.userInfo.authenticated){   
      this.logado = true;     

      let roles : Array<string> = this.adalService.userInfo.profile.roles;
      this.setAccessOptions(roles);  
      console.log("Roles: ", roles);
      this.sessionTimer();
      
      // if(!localStorage.getItem("auditLoginStatus") || localStorage.getItem("auditLoginStatus") == "nok"){
      //   this.userService.auditLogin(this.adalService.userInfo.username); 
      //   localStorage.setItem("auditLoginStatus","ok");
      // }
       
                
    }    
  }

  sessionTimer(){
      this.expiration = this.adalService.userInfo.profile.exp;
      //alert("exp from menu:"+ expp);
      let dataExp = new Date(this.expiration*1000);
      dataExp.setMinutes(dataExp.getMinutes());
      
      var countDownDate = new Date(dataExp).getTime();

      var interval = setInterval(() => {
        
        var now = new Date().getTime();    
        // Find the distance between now an the count down date
        this.distance = countDownDate - now; 
        //console.log(this.distance);
        this.sessionMinutes = Math.floor((this.distance % (1000 * 60 * 60)) / (1000 * 60));
        this.sessionSeconds = Math.floor((this.distance % (1000 * 60)) / 1000);

        if(this.distance > 0 && this.distance <= 65000 && !this.alertShowed){
          this.alertShowed = true;
          alert("ATENÇÂO! Sua sessão expira em 1 minuto. saia e faça login novamente.")
        }

        if (this.distance < 0){
          clearInterval(interval);
        }       

      },1000); 
  }

  setAccessOptions(roles: Array<string>){
    this.permissionService.getMenuItens(roles)
    .then(itens => {
      this.menuItens = itens;
      this.canLogout = true;
      this.user = this.adalService.userInfo.profile.name;
      this.userService.auditLogin(this.adalService.userInfo.username); 
    });     
    
  }

  public logout() {
    //localStorage.removeItem("permissionLevel");
    localStorage.removeItem("tokenExpDate");
    localStorage.removeItem("count");
    //localStorage.removeItem("auditLoginStatus");
    //console.log("limpou o storage");
    //console.log("storage (pl):",localStorage.getItem("permissionLevel"));
    //console.log("storage (ted):",localStorage.getItem("tokenExpDate"));
    this.adalService.logOut(); 
  }


  public setAmbiente(){
    let url:string = window.location.host;
    this.appEnvService.getAppEnvironment().subscribe(env => {
      console.log(env);
      this.ambiente = env;
    },err => {
      this.ambiente = "Erro ao identificar ambiente.";
    })
  }

}



// WEBPACK FOOTER //
// C:/Users/ewerton.w.da.silva/Documents/Visual Studio 2017/Projects/SCL_Valia/SCL_Valia/src/app/navegacao/menu/menu.component.ts